import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import {FireService} from '../fire.service';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss']
})
export class PortfolioComponent implements OnInit {

  projects: Array<any>
  projectIdList: Array<string>

  constructor(
    public fireService: FireService
  ) { }

  ngOnInit(): void {
    this.fireService.getData().subscribe(ret => {
      console.log(ret);
      this.projects = ret.map(project => project)
    })

    this.fireService.getId().subscribe(ret => {
      this.projectIdList = ret.map(each =>
        each.payload.doc.id
      )
    })
  }

}
